import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// The app's EntityFieldStoryEditor keys (@mention feed and fields, image / file attach events), passed to the engine
// editor unchanged: they wire the composer to the app's entities, not to the design.
export default class StoryComposerWiring extends BaseOption {
  static userInterfaceComponent = {
    component: inspectorTools.NONE,
  };

  static defaultValue = {};
}
